import { IconBase, IconComponent } from './BaseIcon';

export const AlignLeft: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M2 2h26v2H2zM2 8.5h14v2H2zM2 15h28v2H2zM2 28h28v2H2zM2 21.5h20v2H2z" />
  </IconBase>
);
